<div class="container pt-3 primaryBgColor h-100 rounded">
  <h4 class="">{{titel}}</h4>
  <p>{{text}}</p>
  <div class="d-flex justify-content-end">

    <button class="btn scButton mb-3 " (click)="confirm()">Ja</button>
    <button class="btn scButton  ml-3 mb-3 " (click)="dismiss()">Nein</button>
  </div>
</div>
